(function () {
    'use strict';

    angular
        .module('display')
        .factory('DisplayService', [
            '_',
            'FacilityVisitRepository',
            DisplayService
        ]);

    function DisplayService(
        _,
        FacilityVisitRepository
    ) {
        return {
            getOrderedVisitNoteList: getOrderedVisitNoteList,
        };

        // returns list of visit notes of patient in the specified time frame ordered by date (least to most recent)
        function getOrderedVisitNoteList(patientId) {
            return FacilityVisitRepository.getVisitNoteList(patientId)
                .then(function(data) {
                    var visitList = data;

                    if(visitList !== null) {
                        var processedVisitList = [];
                        _.each(visitList, function(visit) {
                            processedVisitList.push({
                                VisitId: visit.VisitId,
                                Date: moment(visit.Date),
                            });
                        });
                        processedVisitList.sort(function (a, b) {
                            return b.Date - a.Date;
                        });

                        return {
                            success: true,
                            data: processedVisitList,
                        };
                    } else{
                        return visitList;
                    }

            });
        }
    }

})();